<template>
    <div class="list">
        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>测试管理</el-breadcrumb-item>
            <el-breadcrumb-item>测试结果管理</el-breadcrumb-item>
        </el-breadcrumb>
    
        <!-- 卡片视图区域 -->
        <el-card>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-select 
                        style="width: 80%;" 
                        v-model="formSource.problem_type" 
                        placeholder="请选择测试类型" 
                        @change="getAnswerListFilter"
                        clearable
                    >
                        <el-option 
                            v-for="item in options" 
                            :key="item.id" 
                            :label="item.test_name" 
                            :value="item.id"
                        ></el-option>  
                    </el-select>

                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="openModal(true)">新增结果</el-button>
                </el-col>
            </el-row>
    
            <!-- 测试列表区域 -->
            <el-table :data="tableList" border stripe>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column label="测试类型" prop="user_type"></el-table-column>
                <el-table-column label="测试结果id" prop="type_id"></el-table-column>
                <el-table-column label="分数区间下" prop="range_min"></el-table-column>
                <el-table-column label="分数区间上" prop="range_max"></el-table-column>
                <el-table-column label="测试结果" prop="type"></el-table-column>
                <el-table-column label="测试结果描述" prop="description"></el-table-column>
                <el-table-column label="建议" prop="suggestion"></el-table-column>
                <el-table-column label="备注" prop="remark"></el-table-column>
                <el-table-column label="操作" width="150px">
                    <template v-slot="scope">
                        <!-- 修改按钮 -->
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModal(false, scope.row)"></el-button>
                        <!-- 删除按钮 -->
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeClass(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    
        <!-- 新增 & 修改测试内容区域 -->
        <el-dialog :title="isAdd ? '新增测试' : '修改测试'" :visible.sync="isModal" width="66%" @close="closeModal">
            <el-form :model="formSource" ref="formSource" label-width="90px" :rules="rules">

                <el-form-item label="测试类型" prop="user_type" label-width="160px" required>
                    <el-select v-model="formSource.user_type" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.id" :label="item.test_name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="测试结果id" prop="type_id" label-width="160px" required>
                    <el-input style="width: 20%;" v-model.number="formSource.type_id" placeholder="请输入测试结果id"></el-input>
                </el-form-item>

                <el-form-item
                    label="分数区间下"
                    prop="range_min"
                    label-width="160px"
                    placeholder="请输入分数区间下"
                    :rules="[
                    { required: true, message: '分数不能为空'},
                    { type: 'number', message: '分数必须为数字值'}
                    ]"
                >
                    <el-input style="width: 20%;" v-model.number="formSource.range_min" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item
                    label="分数区间上"
                    prop="range_max"
                    label-width="160px"
                    placeholder="请输入分数区间上"
                    
                >
                    <el-input style="width: 20%;"  v-model.number="formSource.range_max" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="测试结果" prop="type" label-width="160px" required>
                    <el-input v-model="formSource.type" placeholder="请输入测试结果"></el-input>
                </el-form-item>
    
                <el-form-item label="测试结果描述" prop="description" label-width="160px" required>
                    <el-input v-model="formSource.description" placeholder="请输入测试结果描述"></el-input>
                </el-form-item>
                
                <el-form-item label="建议" prop="suggestion" label-width="160px" required>
                    <el-input v-model="formSource.suggestion" placeholder="请输入建议"></el-input>
                </el-form-item>

                <el-form-item label="备注" prop="remark" label-width="160px" required>
                    <el-input v-model="formSource.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="setClass">确 定</el-button>
            </span>
        </el-dialog>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {
                options: [],
                isAdd: true, // 是否为新增测试 默认是
                tableList: [], // 表格数据源
                isModal: false, // 控制对话框的显示与隐藏
    
                formSource: {
                    user_type: null, // 测试id
                    type_id:null,
                    range_min:null,
                    range_max:null,
                    type:'',
                    description:'',
                    suggestion:'',
                    remark:''
                }, // 表单数据
                rules: {
                    range_min:[
                        { required: true, message: '分数不能为空'},
                        { type: 'number', message: '分数必须为数字值'}
                    ],
                    range_max:[
                        { required: true, message: '分数不能为空'},
                        { type: 'number', message: '分数必须为数字值'}
                    ],
                    user_type: [{
                        required: true,
                        message: '测试类型不能为空!',
                        trigger: 'blur'
                    }], 
                    type_id:[{
                        required: true,
                        message: '测试结果id不能为空!',
                        trigger: 'blur'
                    }],
                    type:[{
                        required: true,
                        message: '测试结果不能为空!',
                        trigger: 'blur'
                    }],
                    description:[{
                        required: true,
                        message: '测试结果描述不能为空!',
                        trigger: 'blur'
                    }],
                    suggestion:[{
                        required: true,
                        message: '测试建议不能为空!',
                        trigger: 'blur'
                    }],
                    remark:[{
                        required: true,
                        message: '测试备注不能为空!',
                        trigger: 'blur'
                    }]
                }
            };
        },
        created() {
            this.getAnswerList(); // 获取测试类型列表
            this.getTestList(); // 获取测试
        },
        methods: {
            // 获取测试
            async getTestList() {
                const {
                    data: res
                } = await this.$http.post('getTestList', {});
                if (res.status === 200) {
                    this.options = res['data'] || [];
                } else {
                    this.$message.error(res.msg);
                }
            },
            async getAnswerList() {
                const {
                    data: res
                } = await this.$http.post('getAnswerList', {});
                if (res.status === 200) {
                    this.tableList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            },
            async getAnswerListFilter(selectedId){
                const {
                    data: res
                } = await this.$http.post('getAnswerList', {user_type:selectedId});
                if (res.status === 200) {
                    this.tableList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            },
            openModal(type, data) {
                this.isAdd = type;
                this.isModal = true;
                // 清空表单验证状态
                this.$nextTick(() => {
                  this.$refs.formSource.clearValidate();
                });
                if (!type) {
                    // 如果是编辑，那么拿一下编辑的内容
                    this.formSource = JSON.parse(JSON.stringify(data));
                }
            },
            async setClass() {
              // 先进行表单验证
              this.$refs.formSource.validate(async (valid) => {
                if (valid) {
                  // 验证通过，准备数据
                  let paramsData = {
                    ...this.formSource,
                  };
    
                  try {
                    if (this.isAdd) {
                      // 新增测试
                      const { data: res } = await this.$http.post('addAnswerList', paramsData);
                      if (res.status === 200) {
                        this.isModal = false;
                        this.getAnswerList();
                      } else {
                        this.$message.error(res.msg);
                      }
                    } else {
                      // 修改测试
                      const { data: res } = await this.$http.post('updateAnswerList', paramsData);
                      if (res.status === 200) {
                        this.isModal = false;
                        this.getAnswerList();
                      } else {
                        this.$message.error(res.msg);
                      }
                    }
                  } catch (error) {
                    this.$message.error('请求失败，请稍后再试');
                    console.error(error);
                  }
                } else {
                  // 验证失败，提示用户
                  this.$message.error('请检查表单内容');
                }
              });
            },
            clearSelection() {
                this.formSource.problem_type = null; // 清除选择
            },
            removeClass(data) {
                this.$confirm('此操作将无法恢复, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消', 
                        type: 'warning'
                    })
                    .then(async () => {
                        const {
                            data: res
                        } = await this.$http.post('delAnswerList', {
                            id: data.id
                        });
                        if (res.status === 200) {
                            this.getAnswerList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch(() => {});
            },
            closeModal() {
                this.formSource = {
                    id: null,
                    user_type: null, 
                    type_id:null,
                    range_min:null,
                    range_max:null,
                    type:'',
                    description:'',
                    suggestion:'',
                    remark:''
                };
            }
        }
    };
    </script>
    
    <style lang="less" scoped>
    /* 可以在此处添加样式 */
    </style>
    